import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2 flex items-center space-x-2 space-y-2 py-2" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-2 pt-4" }
const _hoisted_3 = ["checked"]

import { computed, reactive, watch } from 'vue';
import { useVuelidateWithLogging } from '@/composables/useVuelidateWithLogging';
import { TrashIcon } from '@heroicons/vue/solid';

import { email, required, maxLength } from '@/utils/validators';
import { ContactEmailFormState } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactEmailForm',
  props: {
    modelValue: {
        type: Object as () => ContactEmailFormState,
        required: true,
    },
    index: {
        type: Number,
        required: true,
    },
},
  emits: ['update:modelValue', 'remove', 'set-main'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const formState = reactive<ContactEmailFormState>(props.modelValue);

const rules = computed(() => ({
    email: { email, required, maxLength: maxLength(50), _key: {} },
    isMain: { required },
}));

const { v$, $validateWithLogging } = useVuelidateWithLogging(rules, formState);

__expose({
    validate: () => $validateWithLogging(),
});

watch(
    formState,
    () => {
        emit('update:modelValue', formState);
    },
    {
        deep: true,
    },
);

return (_ctx: any,_cache: any) => {
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiTextInput, {
      modelValue: _unref(v$).email.$model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).email.$model) = $event)),
      name: "email",
      type: "text",
      label: _ctx.$t('contact.form.labels.email'),
      class: "flex-1",
      errors: _unref(v$).email.$errors,
      onBlur: _unref(v$).email.$touch
    }, null, 8, ["modelValue", "label", "errors", "onBlur"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "radio",
        checked: formState.isMain,
        class: "text-primary focus:ring-primary mt-0.5",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('set-main')))
      }, null, 40, _hoisted_3), [
        [_directive_tippy, _ctx.$t('contact.form.actions.setMainEmail')]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
        variant: "danger",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('remove', __props.index)))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
        ]),
        _: 1
      })), [
        [_directive_tippy, _ctx.$t('contact.form.actions.removeEmail')]
      ])
    ])
  ]))
}
}

})